import { GetSaveLinkOptions } from '../analytics-context-types';
import { getModalLevel2, getModalTag, getPODProductTag, withAreaEvent } from './utils';

export const getSaveLinkTag = (options: GetSaveLinkOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const level2 = options.onSplashScreen ? 'Hooray' : getModalLevel2(options.productType);

  const saveLinkEvent = [
    {
      eventInfo: {
        eventName: 'save project',
        eventAction: options.eventAction,
      },
    },
  ];

  const { modal, user } = getModalTag(
    options.productType,
    level2,
    withAreaEvent(saveLinkEvent, level2, options.elementPosition),
    options.projectID,
    options.statusMessage,
  );

  return {
    product,
    modal,
    user,
  };
};
